import SetFiscalRegimeError from './SetFiscalRegimeError';
class RegimeFileIsEmpty extends SetFiscalRegimeError {
    constructor(options) {
        super('Fiscal Regime File not has information', options);
    }
}
export default RegimeFileIsEmpty;
